import React from "react";
import {
  Card,
  Divider,
  Statistic,
  Typography,
} from "antd";

const { Text } = Typography;

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const OrderSummary = ({
  totals,
  shippingCost,
  currency = "USD",
  sticky = false,
}) => {
  const grandTotal =
    Number(totals.subtotal || 0) +
    Number(shippingCost || 0);

  return (
    <Card
      title="Order Summary"
      style={{
        borderRadius: 14,
        position: sticky ? "sticky" : "relative",
        top: sticky ? 20 : undefined,
      }}
    >
      <Statistic
        title="Items"
        value={totals.itemCount}
      />

      <Divider style={{ margin: "14px 0" }} />

      <Statistic
        title="Total Quantity"
        value={totals.quantityCount}
      />

      <Divider style={{ margin: "14px 0" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <Text>Subtotal</Text>

        <Text strong>
          {currency}{" "}
          {formatCurrency(totals.subtotal)}
        </Text>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 14,
        }}
      >
        <Text>Shipping</Text>

        <Text strong>
          {currency}{" "}
          {formatCurrency(shippingCost)}
        </Text>
      </div>

      <Divider />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text strong>Grand Total</Text>

        <Text
          strong
          style={{
            fontSize: 22,
            color: "#1677ff",
          }}
        >
          {currency}{" "}
          {formatCurrency(grandTotal)}
        </Text>
      </div>
    </Card>
  );
};

export default OrderSummary;